import React from 'react';
import { Typography } from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';
import ConfirmPopup from '../../../../popup/ConfirmPopup/ConfirmPopup';

const ResultsDialog = ({ 
  showResultsPopup, 
  sendingResults, 
  setShowResultsPopup 
}) => {
  return (
    <ConfirmPopup
      Visibility={showResultsPopup}
      Title="Mensagens Enfileiradas"
      Description={
        <>
          <table style={{ width: '100%', borderCollapse: 'collapse', margin: '10px 0' }}>
            <tbody>
              <tr>
                <td style={{ padding: '12px', borderBottom: '1px solid #eee', textAlign: 'left' }}>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>Total:</Typography>
                </td>
                <td style={{ padding: '12px', borderBottom: '1px solid #eee', textAlign: 'right' }}>
                  <Typography variant="h5" sx={{ fontWeight: 700, color: ColorPalette.secondary }}>
                    {sendingResults?.summary?.total || 0}
                  </Typography>
                </td>
              </tr>
              <tr style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)' }}>
                <td style={{ padding: '12px', borderBottom: '1px solid #eee', textAlign: 'left' }}>
                  <Typography variant="body1" sx={{ fontWeight: 600, color: ColorPalette.textDark }}>
                    Na fila de envio:
                  </Typography>
                </td>
                <td style={{ padding: '12px', borderBottom: '1px solid #eee', textAlign: 'right' }}>
                  <Typography variant="h5" sx={{ fontWeight: 700, color: ColorPalette.textDark }}>
                    {sendingResults?.summary?.success || 0}
                  </Typography>
                </td>
              </tr>
              {(sendingResults?.summary?.failure > 0) && (
                <tr style={{ backgroundColor: 'rgba(244, 67, 54, 0.1)' }}>
                  <td style={{ padding: '12px', textAlign: 'left' }}>
                    <Typography variant="body1" sx={{ fontWeight: 600, color: ColorPalette.textDark }}>
                      Falhas:
                    </Typography>
                  </td>
                  <td style={{ padding: '12px', textAlign: 'right' }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, color: ColorPalette.textDark }}>
                      {sendingResults?.summary?.failure || 0}
                    </Typography>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {(sendingResults?.summary?.queued > 0) && (
            <Typography variant="body2" sx={{ color: ColorPalette.textMedium, marginTop: '8px' }}>
              As mensagens são enviadas gradualmente (cerca de 20 por minuto). Tempo estimado: ~{sendingResults?.summary?.estimated_minutes || 0} min.
            </Typography>
          )}
        </>
      }
      ConfirmLabel="Fechar"
      OnConfirm={() => setShowResultsPopup(false)}
      OnCancel={() => {}}
      OnHide={() => setShowResultsPopup(false)}
    />
  );
};

export default ResultsDialog;